import { unzipSync, strFromU8 } from 'fflate';
import axios from 'axios';
// import { config } from "src"
// export const BASE_URL = 'https://margsahayak.gujarat.gov.in'
export const LOGIN = 'api/v1/client/login'
export const SERVICES = 'Services'
export const CHANGEPASSWORD = 'ChangePassword'
export const SERVICES1 = 'Services1'
export const SERVICES2 = 'Services2'
export const WINGS = 'Wings'
export const DIVISION = 'Division'
export const OFFICE = 'Office'
export const CHARTS = 'GetCharts'
export const SCADA = 'Scada'
export const SAVEDATA = 'SaveData'
export const REFETCHDATA = 'RefetchData'
export const ALLWORKS = 'GetAllWorks'
export const HOTMIX = 'GetHotMixData'
export const MMGSYAPIDATA = 'MMGSYAPIDATA'
export const MMGSYROADDATA = 'MMGSYROADDATA'
export const AgGridFilter = 'AgGridFilter'
export const AgGridFilterChart = 'AgGridFilterChart'
export const APILOG = 'APILOG'

export const HOTMIXDATA = 'GetHotMixPlantData'
export const ALLWORKSDATA = 'GetAllWorkData'
export const HOMECHARTS = 'GetHomeCharts'
export const HOMECHARTS_Temp = 'GetAllCharts_Temp'
export const CHARTLOGIN = 'Login'
export const COMMONCHARTS = 'GetAllCharts_Common'

export const HOMECHARTSDATA = 'GetHomeChartsData'
export const REMOVEDATA = 'RemoveData'
export const RefetchDataExternal = 'RefetchDataExternal'

export const TRANSFERDATA = 'TransferData'

export const MMGSYBRIDGEDATA = 'MMGSYBRIDGEDATA'

export const HOMECHARTSDATA_Temp = 'GetHomeChartsData_Temp'

export const CHARTSWITHFILTER = 'GetChartsWithFilter'
export const ChartTableDetails = 'ChartTableDetails'
export const CHILDTABLEDETAILS = 'ChildTableDetails'
export const Filters = 'GetFilters'
export const Modules = 'GetModules'
export const GETDATA = 'GetData'
export const WatchList = 'WatchList'
export const GetApiLogData = 'GetApiLogData'

export const SaveUpdateData = 'SaveUpdateData'

export const VALIDATE_USER = "ValidateUser"
export const USER_VISIT_COUNT = "UserVisitCount"
export const FORGOT_USERID = "ForgotUserID"
export const FORGOT_PASSWORD = "ForgotPassword"
export const UPDATE_USER = "UpdateUser"
export const FETCH_USER_DETAILS = "FetchUserDetails"
export const CHANGE_PASSWORD = "ChangePassword"
export const FETCH_OFFICE = "FetchOffice"
export const FETCH_DESIGNATION = "FetchDesignation"
export const FETCH_MODULE = "FetchModule"
export const CREATE_USER = "CreateUser"
export const GET_MENU_RIGHT_BASED = "GetMenuRightBased"
export const FETCH_API_DATA = "FetchAPIData"
export const GET_TOTAL_COUNT = "GetTotalCNT"
export const SEARCH_WITH_PAGING = "SRCHWITHPAGING"
export const LIST = "LIST"
export const SOURCE_MMGSY = "MMGSY"
export const SOURCE_STROBES = "STROBES"
export const FETCH_MENU_CODEWISE_OBJECTLIST = "FetchMenucodewiseObjectList"
export const FETCH_OBJECTWISE_DATASET = "FetchObjectwiseDataSet"
export const CREATE_NEWSESSION_FOR_OBJECT_FILTER_REQUEST = "CreateNewSessionForObjectFilterRequest"
export const FETCH_OBJECTWISE_FILTERS = "FetchObjectwiseFilters"
export const FETCH_FILTERWISE_DATA = "FetchFilterswiseData"
export const FILTER_VALUE_SELECTED = "FilterValueSelected"
export const FETCH_OBJECTWISE_DATASET_FILTERED = "FetchObjectwiseDataSetFiltered"
export const REGISTER_GRIEVANCE = "RegisterGrievance"
export const DATA_DRILL_DOWN = "DataDrilldown"
export const BROADCAST_MSG_FETCH = "BroadCastMsg_Fetch"
export const BROADCAST_MSG_SAVE = "BroadCastMessage_Save"
export const FETXHAPILOG_LASTRUN_DETAIL = "FetchAPILOG_LastRunDtl"
export const CHART_CLICK = "ChartClick"
export let FETCH_WORK_DATA_FOR_MAP = 'FetchWorkData4Map';
export let FETCH_MENU_CODEWISE_OBJECTLIST_FOR_DRPT = "FetchMenucodewiseObjectList4DRPT"
export let FETCH_DDL_DRPT = "FetchDDL_DRPT"
export let GET_DIRECT_REPORT = "GetDirectReport"
export let FETCH_PASSWORD_POLICY = "FetchPasswordPolicy"

// export const FILTER_URL = 'http://localhost:50252/webservice/Filters.asmx'

// export const CHARTS_URL = 'http://localhost:50252/webservice/Charts.asmx'

// export const DATAWAREHOUSE_URL = 'http://localhost:50252/webservice/Datawarehouse.asmx'

// export const FILTER_URL = 'http://localhost/dashboardWS/webservice/Filters.asmx'
// export const CHARTS_URL = 'http://localhost/dashboardWS/webservice/Charts.asmx'

//OG one
// export const FILTER_URL = 'http://103.27.120.198/dashboardWSTest/webservice/Filters.asmx'
// export const CHARTS_URL = 'http://103.27.120.198/dashboardWSTest/webservice/Charts.asmx'
// export const DATAWAREHOUSE_URL = 'http://103.27.120.198/dashboardWSTest/webservice/Datawarehouse.asmx'


// const serverIP = process.env.REACT_APP_SERVER_IP




// import { Dashboard } from "@mui/icons-material";

// Declare config object and constants at the top level
// export let config = {};

export let CK_Dsh_DBLogin;
export let CK_Dsh_Strobes;
export let CK_Dsh_MMGSY;
export let CK_Dsh_Gujrams;
export let CK_Dsh_Gujmarg;
export let CK_Dsh_DBData;
export let CK_Dsh_DBData3;
export let MOBILEAPP_LINK;
export let MAP_URL;
export let MAP_URL_ACCESS_TOKEN;
export let MAP_CREDENTIALS;
export let DATAPOOL_RESOURCE;
export let USERMANUAL_URL;
export let CONFIG_COLOR_OBJ;
export let FILTER_URL = 'FILTER_URL_PLACEHOLDER';
export let CHARTS_URL = 'CHARTS_URL_PLACEHOLDER';
export let DATAWAREHOUSE_URL = 'DATAWAREHOUSE_URL_PLACEHOLDER';
export let DASHBOARD_URL = 'DASHBOARD_URL_PLACEHOLDER';
export let DDL_DRPT_URL = 'DDL_DRPT_URL_PLACEHOLDER';
export let WSMIS_URL = 'WSMIS_URL_PLACEHOLDER';
export let WS_DASH_URL = 'WS_DASH_URL_PLACEHOLDER';
// export let WS_DASH_URL3 = 'WS_DASH_URL_PLACEHOLDER';
export let USER_NAME = "USER_NAME_PLACEHOLDER"
export let PASSWORD = "PASSWORD_PLACEHOLDER"
export let JSON_FILES = "JSON_FILES"
export let WEB_DOMAIN = "WEB_DOMAIN_PLACEHOLDER"
export let BASIC_TOKEN_HEADER = {}

export let SHOW_TRAFFIC_STATUS = false

export const loadZipData = async (resourcePath) => {
    try {
        const response = await axios.get(resourcePath, {
            responseType: "arraybuffer",
        });
        const zipBuffer = response.data;




        // Unzip using fflate
        const zip = unzipSync(new Uint8Array(zipBuffer));

        // Extract and parse JSON files
        const cache = {};
        for (const fileName in zip) {
            if (fileName.endsWith(".json")) {
                const json = JSON.parse(strFromU8(zip[fileName]));
                cache[fileName] = json;
            }
        }

        // Store in global cache
        // JSON_FILES = cache;
        return cache

    } catch (error) {
        console.error("Error loading JobSchedulerApp.zip:", error);
    }
};


// Dynamically fetch the configuration file
export let loadConfig = (config) => {
    // WEB_DOMAIN = `${window.location.protocol}//${window.location.hostname}`;
    WEB_DOMAIN = `${window.location.protocol}//103.27.120.198`;

    console.log("see teh hostname:", WEB_DOMAIN)

    DATAPOOL_RESOURCE = config.DATAPOOL_RESOURCE;
    CK_Dsh_DBLogin = `${WEB_DOMAIN}/${config.CK_Dsh_DBLogin}`;
    CK_Dsh_Strobes = config.CK_Dsh_Strobes;
    CK_Dsh_MMGSY = config.CK_Dsh_MMGSY;
    CK_Dsh_Gujrams = config.CK_Dsh_Gujrams;
    CK_Dsh_Gujmarg = config.CK_Dsh_Gujmarg;
    CK_Dsh_DBData = `${WEB_DOMAIN}/${config.CK_Dsh_DBData}`;
    CK_Dsh_DBData3 = `${WEB_DOMAIN}/${config.CK_Dsh_DBData3}`;
    MOBILEAPP_LINK = config.MOBILEAPP_LINK;
    USER_NAME = config.USER_NAME
    PASSWORD = config.PASSWORD
    MAP_URL = config.MAP_URL;
    MAP_URL_ACCESS_TOKEN = config.MAP_URL_ACCESS_TOKEN;
    MAP_CREDENTIALS = config.MAP_CREDENTIALS;
    USERMANUAL_URL = `${WEB_DOMAIN}/${config.MANUAL_URL}`;
    CONFIG_COLOR_OBJ = config.configSideBarColors
    SHOW_TRAFFIC_STATUS = config.SHOW_TRAFFIC_STATUS

    // Now that the config values are set, we can construct the URLs
    FILTER_URL = `${CK_Dsh_DBData}/dashboardWS/webservice/Filters.asmx`;
    CHARTS_URL = `${CK_Dsh_DBData}/dashboardWS/webservice/Charts.asmx`;
    DATAWAREHOUSE_URL = `${CK_Dsh_DBData}/dashboardWS/webservice/Datawarehouse.asmx`;
    DASHBOARD_URL = `${CK_Dsh_DBLogin}/webservice/wsWDMS.asmx`;
    WSMIS_URL = `${CK_Dsh_DBData}/webservice/wsmis.asmx`;
    DDL_DRPT_URL = `${CK_Dsh_DBData3}/webservice/wsMIS_DRPT.asmx`;
    // WS_DASH_URL = `${CK_Dsh_DBData}/webservice/wsDash.asmx`;
    WS_DASH_URL = `${CK_Dsh_DBData3}/webservice/wsDash.asmx`;
    // WS_DASH_URL3 = `${CK_Dsh_DBData3}/webservice/wsDash.asmx`;
    const token = btoa(`${config.USER_NAME}:${config.PASSWORD}`);
    BASIC_TOKEN_HEADER = {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": `Basic ${token}`,
    }
};


// export const basicTokenHeaderGiver = () => {
//     const username = USER_NAME;
//     const password = PASSWORD;
//     const token = btoa(`${username}:${password}`); // base64 encoding
//     const headers = {
//         "Content-Type": "application/json; charset=utf-8",
//         "Authorization": `Basic ${token}`,
//     }
//     return headers
// }

headers: BASIC_TOKEN_HEADER




// Call loadConfig when the app starts
// loadConfig();

// export const FILTER_URL = 'https://api.rnbdashboard.com/webservice/Filters.asmx'
// export const CHARTS_URL = 'https://api.rnbdashboard.com/webservice/Charts.asmx'
// export const DATAWAREHOUSE_URL = 'https://api.rnbdashboard.com/webservice/Datawarehouse.asmx'

// export const FILTER_URL = 'http://localhost/dashboardWS/webservice/Filters.asmx'

// export const CHARTS_URL = 'http://localhost/dashboardWS/webservice/Charts.asmx'

// export const DATAWAREHOUSE_URL = 'http://localhost/dashboardWS/webservice/Datawarehouse.asmx'
